import service from '../services/flow';
import flowHandler from '../handlers/flow';
import { Config } from '../core/config';
import { model } from '../core/model';
import view from '../helpers/view';
import meteringHelper from '../../common/helpers/metering-api-fetch';
import { isWallExcluyente } from "../helpers/flow";

const SUSCRIBEMODE = "S";

const flow = function () {

    try {
        model.Usuario.isLogged().then(isLogged => {
            if (isLogged) {
                meteringHelper.obtenerCookieSuscriptor(Config.apiAuthorize, model.Usuario.xToken, Config.apiAuthorizeInfo)
                    .then(() => {
                        const wallExcluyente = isWallExcluyente();
                        const comboNumber =
                            model.Window.modo.toUpperCase() !== SUSCRIBEMODE &&
                                wallExcluyente
                                ? model.Window.combo : 1;
                        service.getFlow({ flow: 'A', combo: comboNumber })
                            .then(data => {
                                model.Window.lastFlow = 'A'
                                let isPdf = comboNumber === Config.PRODUCTO_PDF;
                                flowHandler.flow(data, isPdf);
                            })
                            .catch(err => {
                                console.log('err', err);
                                flowHandler.flowDefault();
                                view.hidePreloader();
                            });
                    });
            }
            else {
                flowHandler.flowDefault();
                view.hidePreloader();
            }
        })
    }
    catch (ex) {
        window.mostrar_error({
            error: `flowController.flow | No anduvo el flow`
        })
    }
}

const flowS = function () {
    flowHandler.flowDefault();
    view.hidePreloader();
}

export default {
    flow,
    flowS
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/flow.js